webpackJsonp([71],{

/***/ "bsPy":
/***/ (function(module, exports, __webpack_require__) {

var DoubleCircleProgress = (function () {
    function DoubleCircleProgress() {
    }
    return DoubleCircleProgress;
}());
angular.module('animatronApp.doubleCircleProgress', []).component('doubleCircleProgress', {
    bindings: {
        icon: '<',
        val: '<',
        circleTitle: '<',
        bigVal: '<',
        smallVal: '<'
    },
    controller: DoubleCircleProgress,
    templateUrl: __webpack_require__("fVSO")
});


/***/ }),

/***/ "fVSO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/double-circle-progress_064d21911ba1071c40db0bad55e54c2c.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/71-28dc41a6a889e793a2e2.min.js